import './Appheader.css'
function Appheader(){
    return(
    <header className="app-header">
        Phakaphol Picture Albumn JSX
      </header>
    );
}
export default Appheader;